export default class SectionFactory {
  static make (item) {
    if (!SectionFactory.hasOwnProperty(`parse${item.contentTypeAlias}`)) {
      console.log('🔥', '[WARN]', `>>> no parser for ${item.contentTypeAlias} <<<`)
      return undefined
    }

    let $Instance = SectionFactory[`parse${item.contentTypeAlias}`].apply(this, [])

    return new $Instance(item)
  }

  static _loadInstance (name) {
    return require(`./sections/${name}`)
  }

  static parsedstVideoSektion () {
    return SectionFactory._loadInstance('video').default
  }

  static parsedstTekstSektion () {
    return SectionFactory._loadInstance('text').default
  }

  static parsedstCitatSektion () {
    return SectionFactory._loadInstance('quote').default
  }

  static parsedstTekstLinkSektion () {
    return SectionFactory._loadInstance('link').default
  }

  static parsedstVideoKarruselSektion () {
    return SectionFactory._loadInstance('video-slider').default
  }

  static parsedstVideoGroupSektion () {
    return SectionFactory._loadInstance('video-group').default
  }
}



// WEBPACK FOOTER //
// ./src/models/section-factory.js